import React from 'react'
import FloatLabel from '../../../components/FloatLabel';
import { DatePicker, Input, Select } from 'antd';
import { ErrorMessage, Field } from 'formik';
import RadioButton from '../../../components/RadioButton/RadioButton';
import { existingJdOption, genderOptions, JobTypeList, statusList } from '../../mailTemplate/ResignationApproval/helper/resignationApprovalHelper';
import dayjs from 'dayjs';
const { TextArea } = Input;

interface FunctionProps {
  [key: string]: any;
}
const TrfFormFields = (props: FunctionProps) => {
  const { values, setFieldValue, isEdit } = props;
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <div className='flex flex-col lg:grid lg:grid-cols-3 lg:gap-6 gap-3'>
      {
        isEdit ?
          <div className="form-item edit-personal-details">
            <FloatLabel label="Requisition No" name="requisitionNo" value={values.requisitionNo}>
              <Input
                disabled
                type="text"
                className="float-control"
                name="requisitionNo"
                value={values.requisitionNo}
                onChange={(e) => {
                  setFieldValue("requisitionNo", e.target.value);
                }}
              />
            </FloatLabel>
            <ErrorMessage name="requisitionNo" component="div" className="error-message" />
          </div> : null
      }

      <div className="form-item edit-personal-details">
        <FloatLabel label="Company" name="company" value={values.company}>
          <Input
            disabled
            type="text"
            className="float-control"
            name="company"
            value={values.company}
            onChange={(e) => {
              setFieldValue("company", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="company" component="div" className="error-message" />
      </div>
      <div className="form-item edit-personal-details">
        <FloatLabel label="Position / Title" name="positionTitle" value={values.positionTitle}>
          <Input
            disabled
            type="text"
            className="float-control"
            name="positionTitle"
            value={values.positionTitle}
            onChange={(e) => {
              setFieldValue("positionTitle", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="positionTitle" component="div" className="error-message" />
      </div>
      <div className="form-item edit-personal-details">
        <FloatLabel label="Department" name="department" value={values.department}>
          <Input
            disabled
            type="text"
            className="float-control"
            name="department"
            value={values.department}
            onChange={(e) => {
              setFieldValue("department", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="department" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Reporting Person" name="reportingPerson" value={values.reportingPerson}>
          <Input
            disabled
            type="text"
            className="float-control"
            name="reportingPerson"
            value={values.reportingPerson}
            onChange={(e) => {
              setFieldValue("reportingPerson", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="reportingPerson" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Persons Required*" name="personsRequired" value={values.personsRequired}>
          <Input
            type="text"
            className="float-control"
            name="personsRequired"
            value={values.personsRequired}
            onChange={(e) => {
              setFieldValue("personsRequired", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="personsRequired" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="CTC (e.g. 3 LPA - 4 LPA)*" name="ctc" value={values.ctc}>
          <Input
            type="text"
            className="float-control"
            name="ctc"
            value={values.ctc}
            onChange={(e) => {
              setFieldValue("ctc", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="ctc" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details ">
        <span className="block !text-[12px] !text-[#878787]">Gender</span>
        <Field
          name="gender"
          render={({ field, form }: any) => (
            <RadioButton
              {...field}
              options={genderOptions}
              onChange={(newValue: any) => {
                form.setFieldValue(field.name, newValue);
              }}
              disabled={false}
            />
          )}
        />
        <ErrorMessage name="gender" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Age Group (e.g. 21 - 25)" name="ageGroup" value={values.ageGroup}>
          <Input
            type="text"
            className="float-control"
            name="ageGroup"
            value={values.ageGroup}
            onChange={(e) => {
              setFieldValue("ageGroup", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="ageGroup" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Education Background*" name="educationBackground" value={values.educationBackground}>
          <Input
            type="text"
            className="float-control"
            name="educationBackground"
            value={values.educationBackground}
            onChange={(e) => {
              setFieldValue("educationBackground", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="educationBackground" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Experience Required (e.g. 0 - 1)*" name="experienceRequired" value={values.experienceRequired}>
          <Input
            type="text"
            className="float-control"
            name="experienceRequired"
            value={values.experienceRequired}
            onChange={(e) => {
              setFieldValue("experienceRequired", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="experienceRequired" component="div" className="error-message" />
      </div>
      <div className="form-item edit-personal-details">
        <FloatLabel label="Name of the last incumbent*" name="lastIncumbent" value={values.lastIncumbent}>
          <Input
            type="text"
            className="float-control"
            name="lastIncumbent"
            value={values.lastIncumbent}
            onChange={(e) => {
              setFieldValue("lastIncumbent", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="lastIncumbent" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details ">
        <FloatLabel label="Position to be filled within the date*" name="positionFillDate" value={values.positionFillDate ? dayjs(values.positionFillDate) : null}>
          <DatePicker
            placeholder=""
            className="float-control"
            name="positionFillDate"
            value={values.positionFillDate ? dayjs(values.positionFillDate) : null}
            onChange={(date, dateString) => {
              setFieldValue("positionFillDate", dateString);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="positionFillDate" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details">
        <FloatLabel label="Job type*" name="positionFillDate" value={values?.jobType}>
          <Select className='float-control w-full __select-kt' value={values?.jobType} options={JobTypeList} showSearch filterOption={filterOption} placeholder="" optionFilterProp="children"
            onChange={(value) => {
              setFieldValue("jobType", value);
            }}
            suffixIcon={<span className=" text-[#000] material-symbols-outlined" >  arrow_drop_down </span>} />
        </FloatLabel>
        <ErrorMessage name="jobType" component="div" className="error-message" />
      </div>


      <div className="form-item edit-personal-details ">
        <span className="block !text-[12px] !text-[#878787]">Is there an existing JD for this role (Yes / No)*</span>
        <Field
          name="existingJD"
          render={({ field, form }: any) => (
            <RadioButton
              {...field}
              options={existingJdOption}
              onChange={(newValue: any) => {
                form.setFieldValue(field.name, newValue);
              }}
              disabled={false}
            />
          )}
        />
        <ErrorMessage name="existingJD" component="div" className="error-message" />
      </div>

      <div className="form-item edit-personal-details row-span-2 col-span-2">
        <FloatLabel label="Any additional input about this role?" name="additionalInput" value={values.additionalInput}>
          <TextArea
            rows={3}
            style={{ resize: "none", height: "100%" }}
            className="float-control h-full"
            name="additionalInput"
            value={values.additionalInput}
            onChange={(e) => {
              setFieldValue("additionalInput", e.target.value);
            }}
          />
        </FloatLabel>
        <ErrorMessage name="additionalInput" component="div" className="error-message" />
      </div>

      {
        isEdit ? <div className={`form-item edit-personal-details col-span-1 row-span-2 flex flex-col !w-full justify-end`}>
          <FloatLabel label="Status" name="positionFillDate" value={values?.status}>
            <Select className='float-control w-full __select-kt' value={values?.status} options={statusList} showSearch filterOption={filterOption} placeholder="" optionFilterProp="children"
              onChange={(value) => {
                setFieldValue("status", value);
              }}
              suffixIcon={<span className=" text-[#000] material-symbols-outlined" >  arrow_drop_down </span>} />
          </FloatLabel>
          <ErrorMessage name="status" component="div" className="error-message" />
        </div> : null
      }
    </div>
  )
}

export default TrfFormFields